import { Component, Injectable, OnInit, Input } from '@angular/core';
import { BrokerItem } from '../../model/BrokerItem';
import { UrlService } from '../../../shared/services/url.service';
import { BrokerService } from '../../services/broker.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { AuthService } from '../../../authentication/services/auth.service';
import { CountryService } from '../../services/country.service';
import { BrokerApiFilter, BrokerProductFilter } from '../../model/BrokerFilter';

@Component({
  selector: 'app-brokersFilter',
  templateUrl: '../templates/brokerFilter.component.html',
  styleUrls: ['./broker.css']
})

@Injectable()
export class BrokerFilterComponent implements OnInit {
  productFilter: BrokerProductFilter;
  title = 'Brokers Filter';
  Brokers: BrokerItem[];
  allBrokers: BrokerItem[];
  DashboardUrl: string;
  CurrentLanguage: string;
  apiFilter: BrokerApiFilter;
  Countries = [];

  constructor(private urlService: UrlService,
    private brokerService: BrokerService,
    private authService: AuthService,
    private alertService: AlertService,
    private countryService: CountryService) { }

  onBrokerProductFilterChange(event: any): void {
    this.Brokers = this.filterProducts();
  }

  ngOnInit() {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.CurrentLanguage = this.authService.getActualLanguage().cultureNameISO;
    this.countryService.GetCountries().subscribe(result => this.Countries = result);
    this.apiFilter = {
      Name: '',
      Country: '',
      IsActive: false
    }
    this.productFilter = {
      InListing: false,
      InReviews: false,
      InShowcases: false
    }
    this.Filter();
  }

  private filterProducts(): BrokerItem[] {
    let result = this.allBrokers;
    if (this.productFilter.InListing) {
      result = result.filter(b => b.products.listing);
    }
    if (this.productFilter.InReviews) {
      result = result.filter(b => b.products.reviews);
    }
    if (this.productFilter.InShowcases) {
      result = result.filter(b => b.products.showcases);
    }
    return result;
  }

  Filter(): void {
    this.alertService.removeAll();
    this.Brokers = [];
    this.brokerService.GetBrokers(this.CurrentLanguage, this.apiFilter).subscribe(brokers => {
      if (brokers.length > 0) {
        this.allBrokers = brokers;
        this.Brokers = this.filterProducts();
      }
    });
  }

  DeleteBroker(id: string, name: string) {
    var shouldDelete = confirm(`Do you want to delete broker "${name}"?`);
    if (shouldDelete) {
      this.brokerService.DeleteBroker(this.CurrentLanguage, id)
        .subscribe(() => this.DeleteSuccess(id, name), err => this.alertService.add('danger', 'Delete Broker error: ' + err));
    }
  }

  private DeleteSuccess(id: string, name: string) {
    this.alertService.add('success', `Broker "${name}" has been deleted.`);
    var index = this.Brokers.findIndex(b => b.id === id);
    this.Brokers.splice(index, 1);
  };
}



// WEBPACK FOOTER //
// ./src/app/brokers/components/scripts/brokerFilter.component.ts